import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-projet-professionnel-contacts-form',
  templateUrl: './projet-professionnel-contacts-form.component.html',
  styleUrls: ['./projet-professionnel-contacts-form.component.scss']
})
export class ProjetProfessionnelContactsFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
